import { useState, Fragment } from "react";
import { Trans } from "@lingui/macro";
import { toast } from "react-toastify";
import type { IMBOption } from "@molecules/MultiButtonMolecule/interface";
import { Button, Typography, Paper, Box, Grid } from "@mui/material";
import PaginatedListMolecule from "@molecules/PaginatedList";
import ClientRow from "@molecules/ClientRow";
import { ClientModel } from "@models/ClientModel";
import Modal from "@molecules/Modal";
import LayoutModal from "@layouts/modal";
import PartnerCreateOrganism from "@organisms/PartnerCreate";
import PartnerFilterOrganism from "@organisms/PartnerFilter";
import { IClientFilterProps } from "@organisms/PartnerFilter/interface";
import {
  StyledFilterContainer,
  StyledGridItem,
  StyledHeaderContainer,
} from "./styled";
import AddIcon from "@mui/icons-material/Add";
import { useConfirm } from "material-ui-confirm";
import PartnersService from "@services/PartnersService";
import { useUser } from "@hooks";
import { Navigate } from "react-router-dom";

const PartnersPage = () => {
  const [refetchKey, setRefetchKey] = useState<any>(0);
  const [modalOpen, setModalOpen] = useState(false);
  const [drawerDetailClient, setDrawerDetailClient] = useState<any>({});
  const [filter, setFilter] = useState<IClientFilterProps>({ search: "" });
  const [newRow, setNewRows] = useState<ClientModel | undefined>(undefined);
  const [toDelete, setToDeleteFromList] = useState<number | undefined>(
    undefined,
  );
  const [updatedItem, setUpdated] = useState<ClientModel | undefined>(
    undefined,
  );
  const confirm = useConfirm();
  const user = useUser();
  const newClientCreated = (client: ClientModel) => {
    setNewRows(client);
  };

  const handleActionSelect = (param: IMBOption) => {
    if (param.label === "Edit") {
      setModalOpen(true);
      setDrawerDetailClient(param.data.client);
    } else if (param.label === "Delete") {
      confirm({
        title: "Are you sure you want to delete this element?",
        description: "The action is irreversible!",
        cancellationText: "Go back",
        confirmationText: "Delete",
      }).then(() => {
        PartnersService.delete(param.data.client.id).then((res: any) => {
          if (!res.hasErrors()) {
            setToDeleteFromList(param.data.client.id);
            toast(res.getMsgString(), {
              type: "success",
            });
            setRefetchKey(refetchKey + 1);
          } else {
            toast(res.getMsgString(), {
              type: "error",
            });
          }
        });
      });
    }
  };

  return (
    <>
      {user.user.role.name === "inspector" && (
        <Navigate to={"/login"}></Navigate>
      )}
      <Fragment>
        <Modal open={modalOpen} set_open={setModalOpen}>
          <LayoutModal
            title={
              !!drawerDetailClient ? (
                <Trans>Update provider</Trans>
              ) : (
                <Trans>New provider</Trans>
              )
            }
          >
            <PartnerCreateOrganism
              onUpdate={setUpdated}
              onNewClient={newClientCreated}
              client={drawerDetailClient}
              mode={"patch"}
            />
          </LayoutModal>
        </Modal>
      </Fragment>
      <Box sx={{ display: "flex", justifyContent: "space-between" }}>
        <Typography variant={"h1"}>
          <Trans>Settings/Providers</Trans>
        </Typography>
        <Box sx={{ textAlign: "right" }} mb={2}>
          <Button
            variant="outlined"
            onClick={() => {
              setDrawerDetailClient(null);
              setModalOpen(true);
            }}
          >
            <AddIcon></AddIcon> Create provider
          </Button>
        </Box>
      </Box>
      <Box mt={2}>
        <Paper elevation={0} sx={{ padding: "10px" }}>
          <StyledFilterContainer
            mb={3}
            sx={{ maxWidth: "30%", textAlign: "right" }}
          >
            <Box>
              <PartnerFilterOrganism setFilter={setFilter} filter={filter} />
            </Box>
          </StyledFilterContainer>
          <PaginatedListMolecule
            scrollPagination={true}
            filter={filter}
            newRow={newRow}
            idToDelete={toDelete}
            updated={updatedItem}
            renderFunc={(item: ClientModel) => {
              return (
                <ClientRow
                  client={item}
                  onActionSelected={handleActionSelect}
                />
              );
            }}
            header={
              <StyledHeaderContainer sx={{ paddingY: "10px" }}>
                <Grid container>
                  <StyledGridItem
                    sx={{ paddingLeft: "5px" }}
                    item
                    md={5}
                    xs={12}
                  >
                    <Trans>Name</Trans>
                  </StyledGridItem>
                  <StyledGridItem item md={3} xs={12}>
                    <Trans>Email</Trans>
                  </StyledGridItem>
                  <StyledGridItem item md={2} xs={12}>
                    <Trans>Phone</Trans>
                  </StyledGridItem>
                  <StyledGridItem item md={2} xs={12}></StyledGridItem>
                </Grid>
              </StyledHeaderContainer>
            }
            service={PartnersService}
          />
        </Paper>
      </Box>
    </>
  );
};

export default PartnersPage;
